import React from 'react'
import QRcode from './components/QRcode'

export default function App() {
  return (
    <div>
      <QRcode/>
    </div>
  )
}
